import { render, staticRenderFns } from "./vcToolbar.vue?vue&type=template&id=20ca0f57&"
import script from "./vcToolbar.vue?vue&type=script&lang=js&"
export * from "./vcToolbar.vue?vue&type=script&lang=js&"
import style0 from "./vcToolbar.vue?vue&type=style&index=0&id=20ca0f57&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports